const SURVEY_ACTIVITY_EVENT = 'survey-activity';

export function signalSurveyActivity() {
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event(SURVEY_ACTIVITY_EVENT));
  }
}

export { SURVEY_ACTIVITY_EVENT };
